/*
 * Which way this device last signed in — Google, mobile code or email — so
 * the sign-in screen can mark it "Last used" and the person doesn't make a
 * second record by picking another way.
 *
 * The one thing kept past sign-out (GUARDRAILS G1's exception, Lena, 19 Oct
 * 2026: "Method only, survives sign-out"). Only the word: never the email,
 * the number or the name, so the next person on a shared phone learns
 * nothing about who it was.
 */
import { storageService } from './storage.service';

export type SignInMethod = 'google' | 'phone' | 'email';

export const LAST_SIGN_IN_METHOD_KEY = 'mpg_last_sign_in_method';

const METHODS: readonly SignInMethod[] = ['google', 'phone', 'email'];

const isMethod = (value: unknown): value is SignInMethod =>
  typeof value === 'string' && (METHODS as readonly string[]).includes(value);

/** Call only after a sign-in succeeded and its session is stored. */
export const rememberSignInMethod = (method: SignInMethod): void => {
  if (!isMethod(method)) return;
  try {
    storageService.setItem(LAST_SIGN_IN_METHOD_KEY, method);
  } catch {
    /* a device that can't store just shows no badge */
  }
};

/** The method this device last signed in with, or null (nothing, or not one of the three). */
export const lastSignInMethod = (): SignInMethod | null => {
  try {
    const value = storageService.getItem(LAST_SIGN_IN_METHOD_KEY);
    return isMethod(value) ? value : null;
  } catch {
    return null;
  }
};
